import utils from "../utils";
const settings = window.DA.settings;
const maxMBSize = utils.bytesToMb(settings.TRY_DOCUMENT_MAX_SIZE);

export default {
    FILE_TOO_LARGE:
        "Файл больше " + maxMBSize + " Мб. Можно разбить его на несколько файлов поменьше.",
    FILE_TOO_LARGE_PLURAL:
        " больше " + maxMBSize + " Мб. Можно разбить их на несколько файлов поменьше.",
    FILE_TOO_LARGE_SINGULAR:
        " больше " + maxMBSize + " Мб. Можно разбить его на несколько файлов поменьше.",
    FILE_WRONG_TYPE:
        "Форма работает только с файлами Excel и CSV, а у вас какой-то другой. <br/>" +
        "Попробуйте открыть файл в Excel и сохранить.",
    FILE_WRONG_TYPE_PLURAL:
        " — не в формате Excel и CSV. Попробуйте открыть их в Excel и сохранить",
    FILE_WRONG_TYPE_SINGULAR:
        " — не в формате Excel и CSV. Попробуйте открыть его в Excel и сохранить",
    FILE_TOO_MANY_ROWS:
        "Возможно, файл слишком большой. " + "Попробуйте разбить его на несколько частей.",
    FILE_UNEXPECTED_ERROR: `Что-то пошло не так. Пожалуйста, попробуйте еще раз. <br/> 
        Если ошибка повторится, пришлите нам описание проблемы и файл на <a href='mailto:support@dadata.ru'>support@dadata.ru</a>`,
    TOO_MANY_FILES: "Сервис не обработает больше 5 файлов",
};
